export enum CddEmbeddedFields {
  CDD_ACH_VOLUMES_INCOMING = 'CDD_ACH_VOLUMES_INCOMING',
  CDD_ACH_VOLUMES_OUTGOING = 'CDD_ACH_VOLUMES_OUTGOING',
  CDD_DOMESTIC_WIRE_VOLUMES_INCOMING = 'CDD_DOMESTIC_WIRE_VOLUMES_INCOMING',
  CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING = 'CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING',
  CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING = 'CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING',
  CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING = 'CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING',
}
